<template>
  <section
    class="section section-primary is-fullheight animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <!-- Title -->

      <div
        class="columns is-vcentered"
        v-if="!requestloading && !requestsuccess && !cardentered"
      >
        <div class="column is-6 is-offset-3 mt-40 mb-40">
          <!-- Login form -->
          <div
            class="flex-card raised padding-20 animated preFadeInUp fadeInUp pb-90"
          >
            <div
              class="square-icon-box rounded info mt-20 animated preFadeInUp fadeInUp"
            >
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">credit_card</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInUp fadeInUp pb-90">
              <hr />
              <h1 class="title is-4 pb-10">
                رجاء ادخال رقم البطاقة
                <br />
                ل{{ requeststring }}
              </h1>

              <div class="field-body">
                <div class="field has-addons is-fullwidth">
                  <p class="control is-expanded">
                    <input
                      v-model="requestInfo.CardNumber"
                      name="CardNumber"
                      class="input has-text-centered is-large"
                      autofocus
                      placeholder="رقم البطاقة"
                      v-validate="{
                        required: true,
                        numeric: true,
                        min: 16,
                        max: 16,
                      }"
                    />
                  </p>
                </div>
              </div>
              <span
                v-show="errors.has('CardNumber')"
                class="help is-danger is-centered"
                >{{ errors.first("CardNumber") }}</span
              >
            </div>
            <hr />
            <div class="hero-foot has-text-centered mb-10">
              <a
                class="button btn secondary-btn raised btn-align modal-dismiss is-bold is-medium"
                v-on:click="validateBeforeSubmit()"
              >
                <b>تأكيد رقم البطاقة والاستمرار</b>
              </a>
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
      <div
        class="columns is-centered has-text-centered"
        v-else-if="requestloading && !requestsuccess && cardentered"
      >
        <loading
          line-fg-color="#2d3f51"
          size="massive"
          class="margin-100"
          spacing="55"
          text-fg-color="#fff"
          message="الرجاء الإنتظار"
        />
      </div>
      <div
        class="columns is-vcentered"
        v-else-if="requestsuccess && !requestloading && cardentered"
      >
        <div class="column is-6 is-offset-3 mt-80 mb-90">
          <!-- Login form -->
          <div
            class="flex-card raised padding-20 animated preFadeInUp fadeInUp pb-90"
          >
            <div
              class="square-icon-box rounded primary mt-20 animated preFadeInUp fadeInUp"
            >
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">check</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInUp fadeInUp pb-90">
              <hr />
              <h1 class="title is-4 pb-10">
                تم ارسال طلب {{ requeststring }} بنجاح
              </h1>

              <h1 class="subtitle is-5">
                سيتم تنبيهك عند الانتهاء من معالجة طلبك
              </h1>

              <hr />
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered" v-else>
        <div class="column is-6 is-offset-3 mt-40 mb-90">
          <!-- Login form -->
          <div class="flex-card raised padding-20">
            <div class="square-icon-box rounded danger mt-20">
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">close</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInLeft fadeInLeft pb-90">
              <hr />
              <h1 class="title is-4 pb-10">فشل في طلب {{ requeststring }}</h1>

              <h1 class="subtitle is-5">{{ errormessage }}</h1>

              <!-- 
              <h1 class="subtitle is-5">رجاء المحاولة لاحقاً</h1>-->

              <hr />
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";

export default {
  props: ["requeststring", "requestid", "requesturl"],

  data() {
    return {
      requestloading: false,
      requestsuccess: false,
      cardentered: false,
      errormessage: "",
      requestInfo: {
        ServicAction_Id: null,
        Customer_Id: null,
        CardNumber: "",
      },
    };
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.cardentered = true;
          this.sendrequest();
          return;
        }
      });
    },
    sendrequest() {
      this.requestloading = !this.requestloading;

      if (
        this.requeststring == null ||
        this.requestid == null ||
        this.requesturl == null
      ) {
        this.$router.push("/");
      }

      var user = JSON.parse(localStorage.getItem("user"));

      this.requestInfo.Customer_Id = user[1];

      let token = localStorage.getItem("token");
      this.requestInfo.ServicAction_Id = this.requestid;
      console.log(this.requestInfo);
      axios
        .post(this.requesturl, this.requestInfo)
        .then((response) => {
          this.$root.kick(response.data.message);
          console.log(response);
          if (response.data.status === "success") {
            this.requestloading = !this.requestloading;
            this.requestsuccess = !this.requestsuccess;

            // alert("request sent successfully");
          } else if (response.data.status === "fail") {
            this.requestloading = !this.requestloading;
            this.requestsuccess = false;
            console.log(response.data.message);
            this.errormessage = response.data.message;
            // alert("request fail");
          }
        })
        .catch((error) => {
          this.isLoading = !this.isLoading;
          this.message = true;
        });
    },
  },
};
</script>
